import { atomWithReset } from "jotai/utils";

export const rejectBuyerModalAtom = atomWithReset<{
  visible: boolean;
  buyerId: string | null;
}>({
  visible: false,
  buyerId: null
});
